import { brand } from '../utils/brand';
import vitaIcon from '../assets/vita-icon.png';

import {
  FiGrid,
  FiMap,
  FiUsers,
  FiAlertTriangle,
  FiClock,
  FiRadio,
  FiSearch,
  FiBarChart2
} from 'react-icons/fi';

function Sidebar({ activeView, setActiveView }) {
  const sections = [
    {
      title: 'Centro de Control',
      items: [
        { key: 'dashboard', label: 'Dashboard', icon: <FiGrid /> },
        { key: 'busqueda', label: 'Búsqueda Global', icon: <FiSearch /> },
                { key: 'analytics', label: 'Analytics', icon: <FiBarChart2 /> }
      ]
    },
    {
      title: 'Territorio',
      items: [
        { key: 'territorios', label: 'Proyectos', icon: <FiMap /> },
        { key: 'actores', label: 'Stakeholders', icon: <FiUsers /> },
        { key: 'alertas', label: 'Alertas', icon: <FiAlertTriangle /> },
        { key: 'timeline', label: 'Timeline', icon: <FiClock /> }
      ]
    },
    {
      title: 'Inteligencia',
      items: [
        { key: 'rrss', label: 'Inteligencia Social', icon: <FiRadio /> }
      ]
    }
  ];

  return (
    <div style={styles.sidebar} className="vita-sidebar-scroll">
      <div>
        <div style={styles.logoRow}>
          <img src={vitaIcon} alt="VITA" style={styles.logoIcon} />

          <div>
            <div style={styles.logoText}>{brand.name}</div>
            <div style={styles.logoSub}>{brand.tagline}</div>
          </div>
        </div>

        <div style={styles.menu}>
          {sections.map((section) => (
            <div key={section.title} style={styles.section}>
              <div style={styles.sectionTitle}>
                {section.title}
              </div>

              {section.items.map((item) => {
                const isActive = activeView === item.key;

                return (
                  <button
                    key={item.key}
                    style={{
                      ...styles.menuButton,
                      background: isActive
                        ? 'linear-gradient(135deg,#0f766e,#0891b2)'
                        : 'transparent',
                      color: isActive
                        ? 'white'
                        : 'rgba(255,255,255,0.78)',
                      boxShadow: isActive
                        ? '0 12px 28px rgba(8,145,178,0.24)'
                        : 'none',
                      border: isActive
                        ? '1px solid rgba(255,255,255,0.10)'
                        : '1px solid transparent'
                    }}
                    onClick={() => setActiveView(item.key)}
                  >
                    <span style={styles.icon}>{item.icon}</span>
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const styles = {
  sidebar: {
    width: '290px',
    height: '100vh',
    background:
      'radial-gradient(circle at top left,rgba(31,169,122,0.14),transparent 34%), linear-gradient(180deg,#071421 0%,#0a1d33 55%,#081421 100%)',
    padding: '28px 22px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    position: 'sticky',
    top: 0,
    alignSelf: 'flex-start',
    overflowY: 'auto',
    boxSizing: 'border-box',
    boxShadow: '8px 0 30px rgba(0,0,0,0.18)',
    borderRight: '1px solid rgba(255,255,255,0.06)',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none'
  },

  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '32px',
    marginTop: '-8px'
  },

  logoIcon: {
    width: '92px',
    height: '92px',
    objectFit: 'contain',
    marginLeft: '-8px',
    marginRight: '-10px'
  },

  logoText: {
    fontSize: '48px',
    fontWeight: '800',
    color: 'white',
    lineHeight: '1',
    marginTop: '2px',
    marginBottom: '-4px'
  },

  logoSub: {
    marginTop: '-4px',
    color: 'rgba(255,255,255,0.62)',
    fontSize: '13px'
  },

  menu: {
    display: 'flex',
    flexDirection: 'column',
    gap: '22px',
    paddingBottom: '30px'
  },

  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  sectionTitle: {
    color: 'rgba(255,255,255,0.38)',
    fontSize: '11px',
    fontWeight: '900',
    textTransform: 'uppercase',
    letterSpacing: '1.4px',
    marginBottom: '5px',
    paddingLeft: '6px'
  },

  menuButton: {
    border: '1px solid transparent',
    borderRadius: '16px',
    padding: '14px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    fontSize: '15px',
    cursor: 'pointer',
    transition: '0.2s',
    textAlign: 'left',
    fontWeight: '700'
  },

  icon: {
    fontSize: '20px',
    display: 'flex',
    alignItems: 'center'
  }
};

export default Sidebar;